
<template>
  <div>
    <v-dialog 
      v-model="dialog" 
      scrollable 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados do Motorista</span>
        </v-card-title>
        <v-card-text>

          <v-col cols='12'>
              <v-row div v-for="(con, idx) in driver_contacts" :key="`contact-${idx}`">
                <v-col cols="12" class="pa-0" md="6">
                  <v-text-field 
                    v-model="con.celphone" :rules="required"
                    label="Celular" v-mask="'(##) #####-####'" prepend-icon="mdi-cellphone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0" md="6">
                  <v-text-field 
                    v-model="con.telephone" 
                    label="Fixo" v-mask="'(##) ####-####'" prepend-icon="mdi-phone"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field 
                    v-model="con.email" 
                    label="E-mail" type="email" prepend-icon="mdi-email"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field 
                    v-model="con.comment" 
                    label="Comentários" prepend-icon="mdi-comment"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <div class="d-flex justify-end mb-3">
                    <f-btn @click="removeContact(con, idx)" alt_icon="mdi-delete" alt_text="excluir" v-if="con.id" 
                      :disabled="canRemove"
                    ></f-btn>
                    <f-btn class="ml-2" save @click="updateContact(con, idx)" :disabled="!con.celphone">Salvar</f-btn>
                  </div>
                </v-col>
                <v-col>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            <v-btn 
              icon text color="error" 
              :disabled="newContact == 0 || !!driver_contacts[driver_contacts.length -1].id"
              @click="removeContact"
            ><v-icon>mdi-minus</v-icon></v-btn>
            <v-btn 
              icon text color="primary" 
              :disabled="driver_contacts.length == 2"
              @click="incrementContact"
            ><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="closeDialog">Cancelar</f-btn>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>


  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogEditDriverContacts',
  components: {
    ContactForm: () => import('@/_backoffice/_registrations/components/shared/forms/ContactForm.vue'),
    
  },
  mixins: [ validations ],
  props: {
    driver: {
      type: Object,
      default: {}
    },
    dialog:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saving: false,
      newContact: 0,
      contact: {
        id: null,
        telephone: "",
        celphone: "",
        email: "",
        comment: '',
        contactable_type: "Driver",
        contactable_id: this.$route.params.id,
      },
      driver_contacts: []
    }
  },
  methods: {
    setContacts(){
      if(this.driver.contacts){
        let contacts = [...this.driver.contacts.data.map(el => el.attributes)]
        let con = JSON.stringify(contacts)
        this.driver_contacts = JSON.parse(con)
      }else{
        this.driver_contacts.push(this.contact)
      }
    },
    incrementContact(){
      this.newContact += 1
      this.driver_contacts.push(this.contact)
    },
    removeContact(con, idx){
      if(!this.driver_contacts[this.driver_contacts.length -1].id){
        this.driver_contacts.splice((this.driver_contacts.length -1), 1)
      }else{
        this.saving = true
        let success = false
        Api.Contact.delete(con.id).then(r=>{
          success = true
          this.driver_contacts.splice(idx, 1)
          this.addNotification({type: 'success',  msg: `Contato removido com sucesso.`})
        }).catch((err) => {
          console.log(err)
          this.addNotification({type: 'error',  msg: `Ocorreu um erro! O contato não foi removido.`})
        }).finally(() => {
          if(success){this.$emit('refresh')};
          this.saving = false
        })
      }
    },
    closeDialog(){
      this.$emit('closeDialog', 'contacts')
    },  
    updateContact(con, idx) {
      this.saving = true
      let METHOD = con.id ? 'update' : 'create'

      let {telephone,celphone,email,comment} = con
      let contact = {
        telephone,
        celphone,
        email,
        comment,
        contactable_type: 'Driver',
        contactable_id: this.$route.params.id
      }
      if(con.id){contact = {...contact, id: con.id}}

      let success = false
      Api.Contact[METHOD](contact).then(r=> r.data).then(d=> {
        success = true
        this.addNotification({type: 'success',  msg: `Contato motorista 3º, atualizado com sucesso!`})
      }).catch(err=>{
        console.log(err)
        this.addNotification({type: 'error',  msg: `Ocorreu um erro! O contato não foi atualizado.`})
      }).finally(() => {
        this.saving = false
        if(success){this.$emit('refresh')};
        this.closeDialog()
      })
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    canRemove(){
      if (this.driver_contacts.length == 1){
        return true
      }else if(!this.driver_contacts[this.driver_contacts.length - 1].id){
        return true
      }else{
        return false
      }
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.setContacts();
  },
}
</script>

<style scoped>

</style>